
import { Injectable } from '@angular/core';

/* User defined library/components */
import { HttpService } from '../../../core/http.service';
import { BootstrapParams } from '../../../../bootstrap-params';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Client } from '../../../shared/models/scheduling/client.model';
import { Program } from '../../../shared/models/scheduling/program.model';
import { AppointmentDetail } from '../../../shared/models/scheduling/appointmentdetail.model';
import { PaymentOption } from '../../../shared/models/scheduling/paymentOption.model';

@Injectable()
export class OrchestrationApiService {
  constructor(private httpService: HttpService, private bootstrapParams: BootstrapParams) {


  }

  getFlows(clientCode: string, programCode: string, examCode?: string, countryCode?: string): Observable<any> {
    const exmCode = examCode ? '&examCode=' : '';
    examCode = examCode || '';

    const cntryCode = countryCode ? '&countryCode=' + countryCode : '';
    return new Observable((observer: Observer<any>) => {
      this.httpService.get(this.bootstrapParams.OrchestrationRootApiUrl +
        'api/v1/flows/?clientCode=' + clientCode + '&programCode=' + programCode
        + exmCode + examCode
        + cntryCode
        + '&scheduleMethod=Internet')
        .pipe(map(this.getFirstOrDefault))
        .subscribe((rArray) => {
          if (rArray.length && rArray[0].flowSet) {
            observer.next(rArray[0].flowSet);
            observer.complete();
          }
        });
    });
  }

  getExamSetFlows(clientCode: string, programCode: string, examSetId: string, countryCode?: string): Observable<any> {
    const cntryCode = countryCode ? '&countryCode=' + countryCode : '';

    return new Observable((observer: Observer<any>) => {
      this.httpService.get(this.bootstrapParams.OrchestrationRootApiUrl +
        'api/v1/flows/?clientCode=' + clientCode + '&programCode=' + programCode
        + '&examSetId=' + examSetId
        + cntryCode
        + '&scheduleMethod=Internet')
        .pipe(map(this.getFirstOrDefault))
        .subscribe((rArray) => {
          if (rArray.length && rArray[0].flowSet) {
            observer.next(rArray);
            observer.complete();
          }
        });
    });
  }

  public getDateTimeInfo(culture: string) {
    return this.httpService.getWithoutLoader(
      this.bootstrapParams.OrchestrationRootApiUrl +
      'api/v1/localization/datetime?culture=' + culture)
      .pipe(map(this.getFirstOrDefault));
  }

  getCandidateSelectableTA(client: Client, program: Program, selectedAppointments: AppointmentDetail[]): Observable<any> {
    const clientCode = client.code;
    const programCode = program.code;
    const examCode = selectedAppointments[0].exam.code;

    return new Observable((observer: Observer<any>) => {
      this.getFlows(clientCode, programCode, examCode).subscribe((response: any) => {

        // Payment
        let paymentResp: any = response.filter(function (el: any) {
          return el.name == "Payment";
        });
        let paymentOptions: PaymentOption[] = new Array();
        paymentResp[0].data.forEach((payment: any) => {
          let val = payment.parameters;
          for (var j in val) {
            var paymentOptionTemp: PaymentOption = new PaymentOption(j, val[j]);
            paymentOptions.push(paymentOptionTemp);
          }
        });

        response = response.filter(function (el: any) {
          return el.name == "Candidate Selectable";
        });
        // check if testingAccommodations have length
        let showCandidateSelectableView =
          response.length ? !!response[0].data.length : false;

        observer.next({
          showCandidateSelectableView: showCandidateSelectableView,
          paymentOptions: paymentOptions
        });
        observer.complete();
      })
    })

  }

  getConfiguration(keys: string[], clientCode: string, programCode?: string, examCode?: string): Observable<any> {
    return new Observable((observer: Observer<any>) => {

      let client = '?client=' + clientCode;
      let program = programCode ? '&program=' + programCode : '';
      let exam = examCode ? '&exam=' + examCode : '';
      this.httpService.search(this.bootstrapParams.OrchestrationRootApiUrl +
        'api/v1/config/' + client + program + exam,
        keys
      )
        .pipe(map(this.getFirstOrDefault))
        .subscribe((rArray) => {
          observer.next(rArray);
          observer.complete();
        });
    });
  }

  getConfigurationAttributes(keys: string[], clientCode: string, programCode?: string, examCode?: string): Observable<any> {
    return new Observable((observer: Observer<any>) => {

      let client = '?client=' + clientCode;
      let program = programCode ? '&program=' + programCode : '';
      let exam = examCode ? '&exam=' + examCode : '';
      this.httpService.search(this.bootstrapParams.OrchestrationRootApiUrl +
        'api/v2/config/' + client + program + exam,
        keys
      )
        .pipe(map(this.getFirstOrDefault))
        .subscribe((rArray) => {
          observer.next(rArray);
          observer.complete();
        });
    });
  }

  private getFirstOrDefault(apiResponse: any): any {
    let resultArray: any = (apiResponse.results !== undefined) ? apiResponse.results : apiResponse;
    return resultArray;
  }

}